import $ from 'jquery';
import { component as defineComponent } from 'flightjs';
import LoginForm from 'launch/modules/login-form';
import RegistrationForm from 'launch/modules/registration-form';

function Authentication() {
    var source;
    var pending = false;

    this.attributes({
        triggerSelector: '#authentication-modal-trigger',
        loginFormSelector: '#login-form',
        registerFormSelector: '#registration-form',
        showRegisterSelector: '#login-form .classic-modal__description a',
        showLoginSelector: '#registration-form .classic-modal__description a',
    });

    this.setupModal = function() {
        $(document).on('modal:beforeHide:authentication', function(e, modal) {
            if (pending) {
                modal.stop();
            } else {
                modal.proceed();
            }
        });
    };

    this.authenticationRequested = function(e, data) {
        if (data && data.source) {
            source = data.source;
        }

        this.select('triggerSelector')
            .data('modal')
            .show();
    };

    this.authenticationSuccessful = function() {
        this.select('triggerSelector')
            .data('modal')
            .hide();
        this.trigger('authenticationSuccessful', {
            source: source,
        });
    };

    this.showRegistrationForm = function(e) {
        e.preventDefault();
        if (pending) {
            return;
        }
        this.select('registerFormSelector').show();
        this.select('loginFormSelector').hide();
    };

    this.showLoginForm = function(e) {
        e.preventDefault();
        if (pending) {
            return;
        }
        this.select('registerFormSelector').hide();
        this.select('loginFormSelector').show();
    };

    this.requestPending = function() {
        pending = true;
    };

    this.requestFinished = function() {
        pending = false;
    };

    this.after('initialize', function() {
        this.setupModal();

        LoginForm.attachTo('#loginform');
        RegistrationForm.attachTo('#registrationform');

        this.on('click', {
            showRegisterSelector: this.showRegistrationForm,
            showLoginSelector: this.showLoginForm,
        });

        this.on('authenticationRequested', this.authenticationRequested);
        this.on('loginSuccessful', this.authenticationSuccessful);
        this.on('registrationSuccessful', this.authenticationSuccessful);
        this.on('spinnerStart', this.requestPending);
        this.on('spinnerStop', this.requestFinished);
    });
}

export default defineComponent(Authentication);



// WEBPACK FOOTER //
// ./src/web/js/launch/modules/authentication-modal.js